import AppLayout from "../../_layouts/AppLayout";
import { collectRoutes } from "./collect.routes";
import { companyRoutes } from "./company.routes";
import { configureRoutes } from "./configure.routes";
import { customerRoutes } from "./customer.routes";
import { miscPrivateRoutes } from "./misc.routes";
import { pricingRoutes } from "./pricing.routes";
import { proposalRoutes } from "./proposal.routes";
import { selfServeRoutes } from "./selfServe.routes";
import { subscriptionRoutes } from "./subscription.routes";
import { upsellRoutes } from "./upsell.routes";

export const appRoutes = [
    {
        element: <AppLayout />,
        children: [
            ...collectRoutes,
            ...companyRoutes,
            ...configureRoutes,
            ...customerRoutes,
            ...miscPrivateRoutes,
            ...pricingRoutes,
            ...proposalRoutes,
            ...selfServeRoutes,
            ...subscriptionRoutes,
            ...upsellRoutes,
        ]
    }
];
